import React, { useEffect, useState, Suspense } from "react";
import PropTypes from "prop-types";
import withRouter from "../Components/Common/withRouter";

//import Components
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";

import { Outlet } from "react-router-dom";

// Content Loader Component
const ContentLoader = () => (
  <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
    <div className="text-center">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      <p className="mt-2 text-muted">Loading content...</p>
    </div>
  </div>
);

const Layout = (props: any) => {
  const [headerClass, setHeaderClass] = useState("");
  const [layoutModeType, setLayoutModeType] = useState("light");
  
  useEffect(() => {
    const savedMode = localStorage.getItem("layoutMode");
    if (savedMode) {
      setLayoutModeType(savedMode);
    }
  }, []);

  const onChangeLayoutMode = (value: any) => {
    setLayoutModeType(value);
    localStorage.setItem("layoutMode", value);
  };

  // class add remove in header
  useEffect(() => {
    window.addEventListener("scroll", scrollNavigation, true);
  });

  function scrollNavigation() {
    var scrollup = document.documentElement.scrollTop;
    if (scrollup > 50) {
      setHeaderClass("topbar-shadow");
    } else {
      setHeaderClass("");
    }
  }

  useEffect(() => {
    const humberIcon = document.querySelector(".hamburger-icon") as HTMLElement;
    if (humberIcon) {
      const layoutType = document.documentElement.getAttribute('data-layout') || "vertical";
      if (layoutType === "vertical" || layoutType === "twocolumn") {
        humberIcon.classList.remove("open");
      } else {
        humberIcon.classList.add("open");
      }
    }
  }, []);

  return (
    <div className="layout-wrapper ">
      <Header
        headerClass={headerClass}
        layoutModeType={layoutModeType}
        onChangeLayoutMode={onChangeLayoutMode}
      />
      <Sidebar layoutType="vertical" />
      <div className="main-content">
        <Suspense fallback={<ContentLoader />}>
          <Outlet />
        </Suspense>
        <Footer />
      </div>
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.object,
};

export default withRouter(Layout);
